import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/rajshekhar26/cleanfolio'
      className='link footer__link'
      target="_blank"
      rel="noreferrer"
    >
      {/* Inspired by rajshekhar26. */}
    </a>
  </footer>
)

export default Footer
